// src/components/invoices/SendInvoiceConfirmDialog.tsx
import { Button, Dialog, Portal, Text } from '@chakra-ui/react'

interface SendInvoiceConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isSending?: boolean
  invoiceNumber?: string | null
  contactName?: string | null
  contactEmail?: string | null
}

export function SendInvoiceConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  isSending = false,
  invoiceNumber,
  contactName,
  contactEmail,
}: SendInvoiceConfirmDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open && !isSending) onClose()
      }}
      size="lg"
      closeOnInteractOutside={!isSending}
      closeOnEscape={!isSending}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Rechnung versenden</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text>
                Die Rechnung {invoiceNumber ? <b>{invoiceNumber}</b> : null} wird per E-Mail
                {contactName ? (
                  <>
                    {' '}
                    an <b>{contactName}</b>
                  </>
                ) : (
                  ' an den Rechnungsempfänger'
                )}
                {contactEmail ? (
                  <>
                    {' ('}
                    <b>{contactEmail}</b>)
                  </>
                ) : null}{' '}
                versandt.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button variant="outline" onClick={onClose} disabled={isSending}>
                Abbrechen
              </Button>

              <Button colorPalette="blue" onClick={onConfirm} loading={isSending}>
                Rechnung versenden
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
